import React from 'react';
import { Tabs, Layout, Breadcrumb } from 'antd';
import CryptoSettings from './CryptoSettings';
import FiatSettings from './FiatSettings';
import DepositHistory from './DepositHistory';
import { SafetyCertificateOutlined, DollarOutlined, HistoryOutlined } from '@ant-design/icons';

const { Content } = Layout;

const DepositManagement = () => {
    const items = [
        {
            key: '1',
            label: (
                <span>
                    <SafetyCertificateOutlined />
                    Crypto Settings
                </span>
            ),
            children: <CryptoSettings />,
        },
        {
            key: '2',
            label: (
                <span>
                    <DollarOutlined />
                    Fiat Settings
                </span>
            ),
            children: <FiatSettings />,
        },
        {
            key: '3',
            label: (
                <span>
                    <HistoryOutlined />
                    Deposit History
                </span>
            ),
            children: <DepositHistory />,
        },
    ];

    return (
        <div style={{ padding: '0px' }}>
            <div className='display-2 mb-10'>
                <h2>Deposit Management</h2>
            </div>
            <Tabs
                defaultActiveKey="1"
                items={items}
                className="custom-tabs"
            />
        </div>
    );
};

export default DepositManagement;
